<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <div>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      breadcrumb: [],
    };
  },
  watch: {
    $route() {
      this.setBreadcrumb()
    },
  },
  methods: {
    setBreadcrumb() {
      // console.log('this', this);
      // console.log('$route', this.$route);
      const { path, name, meta: { cnname } } = this.$route;
      this.breadcrumb = []
      const object = this.navMenu
      for (const key in object) {
        if (Object.prototype.hasOwnProperty.call(object, key)) {
          const element = object[key];
          if (path.includes(element.value)) {
            // console.log({ ...element })
            this.breadcrumb.push({
              name: element.name,
              // path: element.value,
            })
            if (element.children && element.children.length) {
              element.children.map(v => {
                // console.log({ ...v })
                if (path.includes(v.value)) {
                  this.breadcrumb.push({
                    name: v.name,
                    // path: v.value,
                  })
                  if (!path.includes('/table')) {
                    this.breadcrumb.push({
                      name: name || cnname,
                    })
                    this.breadcrumb[0].path = this.breadcrumb[1].path = v.value
                  }
                }
              })
            }
          }
        }
      }
    },
  },
  mounted() {
    this.setBreadcrumb()
  },
};
</script>

<style lang="less" scoped></style>
